import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import TagManager from 'react-gtm-module';

const useLocationTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const pageView = {
      event: 'pageview',
      page: {
        url: location.pathname,
      },
    };

    const anotherEvent = {
      event: `tl_${location.pathname}`,
      page: {
        id: `tl_${location.pathname}`,
        url: location.pathname,
      },
    };

    TagManager.dataLayer({
      dataLayer: pageView,
    });

    TagManager.dataLayer({
      dataLayer: anotherEvent,
    });
  }, [location]);
};

export default useLocationTracking;
